import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Mixins } from 'vue-property-decorator'

import WindowResizeMixin from "./WindowResizeMixin";

@Component
export default class DrawerWidthMixin extends Mixins(WindowResizeMixin) {
  private initWidth = 600

  initializeSidebarWidth(width:number):void {
    this.initWidth = width
  }

  get drawerWidth(): number | string {
    if (isMobile() || this.windowWidth <= 768 || this.windowWidth < this.initWidth) {
      return this.windowWidth
    }

    return this.initWidth
  }
}
